//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { Modal } from 'react-bootstrap'
//@end

//@import components
import IconComponent from 'app_components/commons/icons'
//@end

// @import hooks
import { useColors } from 'app_hooks/useColors'
// @end

// @INFO Import types
import { IBulkUploadModalHeader } from 'app_types/admin/bulkUploadModal/bulkUploadModalTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../bulkUploadModalModule.scss'

// @ADD Component types
interface IBulkUploadModalModuleLayoutProps {
  open: boolean
  processing: boolean
  handleClose: (data: any) => void
  onHandleSubmit: (data: any) => void
  header?: IBulkUploadModalHeader
  helperFile?: string
  errors: Array<any>
}

const BulkUploadModalModuleLayout: React.FC<IBulkUploadModalModuleLayoutProps> = (props) => {

  const [colors] = useColors()

  const { t } = useTranslation()
  const formHook = useForm()

  const { open } = props

  const handleCloseModal = (data: any) => {
    props.handleClose(data)
  }

  return (
    <div className=''>
      <Modal show={open} onHide={() => handleCloseModal({ status: false })} className="bulk_upload_modal-component">
        {props?.header && (
          <Modal.Header>
            <Modal.Title>
              {props?.header?.title && (props.header.title)}
            </Modal.Title>
            {props?.header?.closeButton && (
              <div className="close-button" onClick={() => handleCloseModal({ status: false })}>
                <IconComponent
                  color={colors.secondary}
                  width='1.5rem'
                  height='1.5rem'
                  fontawesome={{
                    icon: 'fas fa-times-circle',
                  }}
                />
              </div>
            )}
          </Modal.Header>
        )}
        <Modal.Body>
          {props.errors && Array.isArray(props.errors) && props.errors.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">{t('modules.bulk_upload_modal.errors_modal.table.row')}</th>
                  {/* <th scope="col">{t('modules.bulk_upload_modal.errors_modal.table.status')}</th> */}
                  <th scope="col">{t('modules.bulk_upload_modal.errors_modal.table.message')}</th>
                </tr>
              </thead>
              <tbody>
                {props.errors.map((item) => (
                  <tr key={item.row}>
                    <td>{item.row}</td>
                    {/* <td>{item.status}</td> */}
                    <td>{item.messageProcess}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <form onSubmit={formHook.handleSubmit(props.onHandleSubmit)} className="bulk-upload-form">
              <div className="form-group">
                <label htmlFor='file_xlsx'>{t('labels.file')}</label>
                <input
                  id='file_xlsx'
                  name='file_xlsx'
                  className={`form-control ${formHook.errors.file_xlsx && 'is-invalid'}`}
                  type='file'
                  ref={formHook.register({ required: true })}
                  required={true}
                  placeholder=' '
                />
                {formHook.errors.file_xlsx && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>

              {props?.helperFile && (
                <div className="helper-file">
                  {t('modules.bulk_upload_modal.helper_file.title')}&nbsp;
                  {
                    <a download='example.xlsx' href={`${props.helperFile}`} target='_blank' rel="noreferrer">
                      {t('modules.bulk_upload_modal.helper_file.href')}
                    </a>
                  }
                </div>
              )}

              <div className='buttons-group'>
                <div className='text-center'>
                  <button className='btn btn-secondary' type='submit' disabled={props.processing}>
                    {props.processing && (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;</>)}
                    {t('modules.bulk_upload_modal.form.save')}
                  </button>
                </div>
              </div>
            </form>
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default BulkUploadModalModuleLayout
